import axios from 'axios';

import {getBaseURL} from "./helpers";


const instance = axios.create({
    baseURL: getBaseURL() + "api/"
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios.js